// Prix par devise (en centimes) — source unique pour le checkout et la landing.
export const HOURLY_RATE_BY_CURRENCY: Record<string, number> = {
  EUR: 790, GBP: 690, USD: 890, CAD: 1190, AUD: 1290, NZD: 1490, MXN: 14000, ARS: 980000,
}
export const MONTHLY_PRICE_BY_CURRENCY: Record<string, number> = {
  EUR: 4999, GBP: 4499, USD: 5499, CAD: 6999, AUD: 7499, NZD: 8499, MXN: 99900, ARS: 7090000,
}
export const DAILY_PRICE_BY_CURRENCY: Record<string, number> = {
  EUR: 1499, GBP: 1299, USD: 1699, CAD: 2199, AUD: 2399, NZD: 2699, MXN: 29900, ARS: 2100000,
}

export const getPlanPrices = (currency?: string) => {
  const cur = currency || 'EUR'
  return {
    hourlyRate: HOURLY_RATE_BY_CURRENCY[cur] || 790,
    monthlyPrice: MONTHLY_PRICE_BY_CURRENCY[cur] || 4999,
    dailyPrice: DAILY_PRICE_BY_CURRENCY[cur] || 1499,
  }
}
